import React, { useState } from "react";
import { Link } from "gatsby";
import GoogleCSE from "./GoogleCSE";
import "./seach-bar.css";

const Sidebar = () => {

  const [isMainOpen3, setMainOpen3] = useState(false);
  const toggleMainDropdown3 = () => {
    setMainOpen3(!isMainOpen3);
  };

  return (
    <div className="sidenav">
      {/* Main Dropdown 1 */}
      <a href="/">
        <button className="dropdown-btn-mobile">
          <a href="/">Home</a>
        </button>
      </a>

      {/* Main Dropdown 3 */}
      <button className="dropdown-btn-mobile" onClick={toggleMainDropdown3}>
        <a>About Beira Brush</a> &nbsp;
        {isMainOpen3 ? (
          <span style={{ color: "#000", marginLeft: "100px" }}>&#9660;</span>
        ) : (
          <span style={{ color: "#7e743e", marginLeft: "100px" }}>&#9660;</span>
        )}
      </button>
      {isMainOpen3 && (
        <div className="dropdown-container-mobile">
          <Link to="/company/">&#187;&nbsp;&nbsp;Company</Link>
          <Link to="/quality/">&#187;&nbsp;&nbsp;Quality</Link>
          <Link to="/sustainability/">&#187;&nbsp;&nbsp;Sustainability</Link>
        </div>
      )}

      {/* Main Dropdown 2 */}
      <a href="/store/">
        <button className="dropdown-btn-mobile">
          <a href="/store/">Product Range</a>
        </button>
      </a>

      {/* Main Dropdown 4 */}
      <a href="/factories/">
        <button className="dropdown-btn-mobile">
          <a href="/factories/">Factories</a>
        </button>
      </a>

      {/* Main Dropdown 5 */}
      <a href="/contact-us/">
        <button className="dropdown-btn-mobile">
          <a href="/contact-us/">Contact</a>
        </button>
      </a>

      {/* Main Dropdown 6 */}
      {/* <a href="/faq-page/">
        <button className="dropdown-btn-mobile">
          <a href="/faq-page/">FAQ</a>
        </button>
      </a> */}

      <div>
        <GoogleCSE />
      </div>
    </div>
  );
};

export default Sidebar;
